function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (a, b) {
  (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = b() : typeof define === 'function' && define.amd ? define(b) : a.VueDisqus = b();
}(this, function () {
  'use strict';

  var a = {
    render: function render() {
      var a = this,
          b = a.$createElement,
          c = a._self._c || b;
      return c('div', {
        attrs: {
          "id": "disqus_thread"
        }
      });
    },
    staticRenderFns: [],
    name: 'vue-disqus',
    props: {
      shortname: {
        type: String,
        required: !0
      },
      identifier: {
        type: String,
        required: !1
      },
      url: {
        type: String,
        required: !1
      },
      title: {
        type: String,
        required: !1
      },
      remote_auth_s3: {
        type: String,
        required: !1
      },
      api_key: {
        type: String,
        required: !1
      },
      sso_config: {
        type: Object,
        required: !1
      },
      language: {
        type: String,
        required: !1
      }
    },
    mounted: function mounted() {
      if (window.DISQUS) {
        this.reset(window.DISQUS);
        return;
      }

      this.init();
    },
    methods: {
      reset: function reset(a) {
        var b = this;
        a.reset({
          reload: !0,
          config: function config() {
            b.setBaseConfig(this);
          }
        });
      },
      init: function init() {
        var _this = this;

        var a = this;

        window.disqus_config = function () {
          a.setBaseConfig(this);
        };

        setTimeout(function () {
          var a = document,
              b = a.createElement('script');
          b.setAttribute('id', 'embed-disqus');
          b.setAttribute('data-timestamp', +new Date());
          b.type = 'text/javascript';
          b.async = !0;
          b.src = "//".concat(_this.shortname, ".disqus.com/embed.js");
          (a.head || a.body).appendChild(b);
        }, 0);
      },
      setBaseConfig: function setBaseConfig(a) {
        var _this2 = this;

        a.page.identifier = this.identifier || this.$route.path || window.location.pathname;
        a.page.url = this.url || this.$el.baseURI;
        this.title && (a.page.title = this.title);
        this.remote_auth_s3 && (a.page.remote_auth_s3 = this.remote_auth_s3);
        this.api_key && (a.page.api_key = this.api_key);
        this.sso_config && (a.sso = this.sso_config);
        this.language && (a.language = this.language);
        a.callbacks.onReady = [function () {
          _this2.$emit('ready');
        }];
        a.callbacks.onNewComment = [function (a) {
          _this2.$emit('new-comment', a);
        }];
      }
    }
  };

  function b(b) {
    b.component('VueDisqus', a);
  }

  typeof window !== 'undefined' && typeof window.Vue !== 'undefined' && window.Vue.use(b);
  return b;
});